import { render } from "./AdvertisementDetail.vue?vue&type=template&id=575c68b6"
import script from "./AdvertisementDetail.vue?vue&type=script&lang=js"
export * from "./AdvertisementDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__